import AppData from "../../../public/const/app_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ScratchTicketCom extends cc.Component {

  private readonly CALC_RECT_WIDTH = 50;
  private readonly CLEAR_LINE_WIDTH = 50;

  @property(cc.Node)
  maskNode: cc.Node = null;

  @property(cc.Node)
  coverNode: cc.Node = null;

  @property(cc.Label)
  progerss: cc.Label = null;

  public showAll : boolean = false;

  @property
  index : number = 0;

  showAllCallback : (percent : number) => void;

  onLoad() {
    this.reset();
    this.coverNode.on(cc.Node.EventType.TOUCH_START, this.touchStartEvent, this);
    this.coverNode.on(cc.Node.EventType.TOUCH_MOVE, this.touchMoveEvent, this);
    this.coverNode.on(cc.Node.EventType.TOUCH_END, this.touchEndEvent, this);
    this.coverNode.on(cc.Node.EventType.TOUCH_CANCEL, this.touchEndEvent, this);
  }


  private touchStartEvent(event : cc.Event.EventTouch) {

    let eventLoca = event.getLocation();
    let point = this.coverNode.convertToNodeSpaceAR(eventLoca);    

    console.log("  touchStartEvent ",point.x , " " , point.y ,"|" , eventLoca.x , " " , eventLoca.y);

    // if (!this.checkPoint(point)) {
    //   return;
    // }

    this.clearMask(point);
    this.calcProgress();
  }

  private checkPoint(point){

    const xFlag = point.x > this.node.x && point.x < this.node.x + this.node.width;
    const yFlag = point.y > this.node.y && point.y < this.node.y + this.node.height;

    return xFlag && yFlag;
  }

  private touchMoveEvent(event) {

    let eventLoca = event.getLocation();
    let point = this.coverNode.convertToNodeSpaceAR(eventLoca);

    console.log("  touchStartEvent ",point.x , " " , point.y ,"|" , eventLoca.x , " " , eventLoca.y);

    // if (!this.checkPoint(point)) {
    //   return;
    // }

    this.clearMask(point);
    this.calcProgress();
  }

  private touchEndEvent() {
    this.tempDrawPoints = [];
    this.calcProgress();
  }

  private calcDebugger: boolean = false && AppData.testMode; // 辅助开关，开启则会绘制划开涂层所属的小格子
  private calcProgress() {
    let hitItemCount = 0;
    let ctx = this.coverNode.getComponent(cc.Graphics);
    this.polygonPointsList.forEach((item) => {
      if (!item.isHit) return;
      hitItemCount += 1;

      if (!this.calcDebugger || !ctx) return;
      ctx.rect(item.rect.x, item.rect.y, item.rect.width, item.rect.height);
      ctx.fillColor = cc.color(216, 18, 18, 255);
      ctx.fill();
    });

    let percent = (hitItemCount / this.polygonPointsList.length);
    
    if (percent >= 0.5) {
      
      //显示全部      
      this.maskNode.active = false;            

      if (this.showAllCallback) {
        this.showAllCallback(percent);
      }

      this.showAll = true;

    }else{
      this.showAll = false;
    }

    //console.log(" percent " , percent)

    //this.progerss.string = `已经刮开了 ${percent * 100}%`;
  }

  private tempDrawPoints: cc.Vec2[] = [];
  private clearMask(pos) {
    let mask: any = this.maskNode.getComponent(cc.Mask);
    let stencil : cc.Graphics = mask._graphics;
    const len = this.tempDrawPoints.length;
    this.tempDrawPoints.push(pos);

    if (len <= 1) {
      // 只有一个点，用圆来清除涂层
      stencil.circle(pos.x, pos.y, this.CLEAR_LINE_WIDTH / 2);
      stencil.fill();

      // 记录点所在的格子
      this.polygonPointsList.forEach((item) => {
        if (item.isHit) return;
        const xFlag = pos.x > item.rect.x && pos.x < item.rect.x + item.rect.width;
        const yFlag = pos.y > item.rect.y && pos.y < item.rect.y + item.rect.height;
        if (xFlag && yFlag) item.isHit = true;
      });
    } else {
      // 存在多个点，用线段来清除涂层
      let prevPos = this.tempDrawPoints[len - 2];
      let curPos = this.tempDrawPoints[len - 1];

      stencil.moveTo(prevPos.x, prevPos.y);
      stencil.lineTo(curPos.x, curPos.y);
      stencil.lineWidth = this.CLEAR_LINE_WIDTH;
      stencil.lineCap = cc.Graphics.LineCap.ROUND;
      stencil.lineJoin = cc.Graphics.LineJoin.ROUND;
      //stencil.strokeColor = cc.color(255, 255, 255, 255);
      stencil.stroke();

      // 记录线段经过的格子
      this.polygonPointsList.forEach((item) => {
        item.isHit = item.isHit || cc.Intersection.lineRect(prevPos, curPos, item.rect);
      });
    }
  }

  private polygonPointsList: { rect: cc.Rect; isHit: boolean }[] = [];
  reset() {

    this.showAll = false;

    this.maskNode.active = true;

    let mask: any = this.maskNode.getComponent(cc.Mask);
    mask._graphics.clear();

    this.tempDrawPoints = [];
    this.polygonPointsList = [];
    //this.progerss.string = '已经刮开了 0%';
    let graphicsCom = this.coverNode.getComponent(cc.Graphics);
    if (graphicsCom) {
      graphicsCom.clear();
    }    

    // 生成小格子，用来辅助统计涂层的刮开比例
    for (let x = 0; x < this.coverNode.width; x += this.CALC_RECT_WIDTH) {
      for (let y = 0; y < this.coverNode.height; y += this.CALC_RECT_WIDTH) {
        this.polygonPointsList.push({
          rect: cc.rect(x - this.coverNode.width / 2, y - this.coverNode.height / 2, this.CALC_RECT_WIDTH, this.CALC_RECT_WIDTH),
          isHit: false
        });
      }
    }
  }
}

